//when local map scripts are loadet (this file is last in the map bundle), load google maps script
var loadJS = function (src, cb) {
    "use strict";
    var ref = document.getElementsByTagName("script")[0];
    var script = document.createElement("script");
    script.src = src;
    script.async = true;
    ref.parentNode.insertBefore(script, ref);
    if (cb && typeof (cb) === "function") {
        script.onload = cb;
    }
    return script;
};
loadJS($('#map-container').attr('data-mapsrc'), function() {
    ReactDOM.render(React.createElement(GoogleMap, {
        model: mapDataModel,
        infoWindows: mapInfoWindows
    }), document.getElementById("map-container"));
});

